import { initializeApp } from "firebase/app";
import { getStorage, ref } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyAW5S06gTPjsX0JjK7gMYwdOpgyAt5X-hg",
  authDomain: "qhealth-85467.firebaseapp.com",
  projectId: "qhealth-85467",
  storageBucket: "qhealth-85467.appspot.com",
  messagingSenderId: "499682378282",
  appId: "1:499682378282:web:13e74b29cf450c8bb0f953",
  measurementId: "G-W1VK5ETTCW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
